export default __webpack_public_path__ + "static/media/The_Nest_large_8.a1f56eb7.jpg";